import React from "react"
import { ToastProvider } from "react-toast-notifications"
import Routes from "./layout/routes/Routes"

const App = () => {
  return (
    <>
      <ToastProvider autoDismiss={true}>
        <Routes />
      </ToastProvider>
    </>
  )
}

export default App
